import React, { useEffect, useState } from "react";
import AlmeApp from "./components/AlmeApp/AlmeApp";
import { defaultTenant } from "./components/AlmeTenantSelector/AlmeTenants";
import "./fontAwesome";
import "./assets/styles/styles.css";
import { ThemeWrapper } from "./components/AlmeTenantSelector/ThemeWrapper";
import ErrorBoundary from "./components/ErrorBoundary/ErrorBoundary";
const App = (props) => {
    const [tenant, setTenant] = useState(defaultTenant);
    const appConfig = Object.assign(Object.assign({}, props.appConfig), { clientName: tenant.name.toLowerCase() });
    appConfig.setTenant = setTenant;
    useEffect(() => {
        function onResize() {
            document.documentElement.style.setProperty("--vh", `${window.innerHeight}px`);
            document.documentElement.style.setProperty("--sw", `${document.body.offsetWidth - document.body.clientWidth}px`);
        }
        window.addEventListener("resize", onResize);
        onResize();
    }, []);
    /**
     * Theme provider requires a non null value, so assigning default theme if app not initialized
     */
    return (React.createElement(ErrorBoundary, { appConfig: appConfig },
        React.createElement(ThemeWrapper, { tenant: tenant, uiLogLevel: appConfig.UiLogLevel },
            React.createElement(AlmeApp, { isOpen: props.isOpen, onClose: props.onClose, onMinimize: props.onMinimize, appConfig: appConfig }))));
};
export default App;
